import type { ComponentStyleConfig } from '@chakra-ui/react';

const OverlineNoMargin: ComponentStyleConfig = {
  baseStyle: {
    display: 'block',
    marginBlockEnd: 0,
    fontFamily: 'body',
    fontSize: { base: 'xs', md: 'sm' },
    fontWeight: 'black',
    color: '#747474',
    textTransform: 'uppercase',
    lineHeight: 'shorter',
    letterSpacing: 'widest',
    wordSpacing: '0.125em',
  },
  sizes: {
    xs: {
      fontSize: { base: 'xs', md: 'sm' },
    },
  },
  defaultProps: {
    size: 'xs',
    colorScheme: 'gray',
  },
};

export default OverlineNoMargin;
